import { useEffect, useState } from 'react';
import { client, urlFor } from '../lib/sanity';
import ProductCard from './ProductCard';
import ProductModal from './ProductModal';

function Gallery({ categorySlug, intro }) {
  const [products, setProducts] = useState([]);
  const [selectedProduct, setSelectedProduct] = useState(null);

  useEffect(() => {
    if (!categorySlug) return;
    client
      .fetch(
        `*[_type == "artwork" && category->slug.current == $cat]
           | order(order asc) {
             _id, title, description, materials, image
           }`,
        { cat: categorySlug }
      )
      .then((artworks) => {
        const mapped = artworks.map((a) => ({
          _id: a._id,
          title: a.title,
          description: a.description,
          materials: a.materials,
          image: urlFor(a.image).width(1200).quality(80).format('webp').url(),
          fullImage: urlFor(a.image).width(2400).quality(85).format('webp').url(),
        }));
        setProducts(mapped);
      });
  }, [categorySlug]);

  return (
    <section className="product-grid-section">
      {intro && <p className="product-grid-intro">{intro}</p>}

      <div className="product-grid-container">
        {products.length > 0 ? (
          products.map((product) => (
            <div key={product._id} onClick={() => setSelectedProduct(product)}>
              <ProductCard image={product.image} title={product.title} />
            </div>
          ))
        ) : (
          <p className="no-products-message">
            No products in this category yet. Check back soon!
          </p>
        )}
      </div>

      <ProductModal
        product={
          selectedProduct
            ? { ...selectedProduct, image: selectedProduct.fullImage }
            : null
        }
        onClose={() => setSelectedProduct(null)}
      />
    </section>
  );
}

export default Gallery;
